import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRightIcon, LeafIcon } from 'lucide-react';
const WelcomeSection = () => {
  return <section className="py-24 bg-[#f8f9f4] relative overflow-hidden" data-id="element-494">
      {/* Background decorative elements */}
      <div className="absolute -top-20 -right-20 w-64 h-64 rounded-full bg-[#e8f5e9] opacity-30 blur-3xl" data-id="element-495"></div>
      <div className="absolute bottom-20 -left-20 w-64 h-64 rounded-full bg-[#e8f5e9] opacity-30 blur-3xl" data-id="element-496"></div>
      <div className="container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-497">
        <div className="grid md:grid-cols-2 gap-16 items-center" data-id="element-498">
          <div data-id="element-499">
            <div className="inline-flex items-center px-4 py-2 bg-[#e8f5e9] text-[#2e7d32] text-sm font-medium rounded-full mb-6" data-id="element-500">
              <LeafIcon className="h-4 w-4 mr-2" data-id="element-501" />
              <span data-id="element-502">Our Story</span>
            </div>
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 leading-tight mb-6" data-id="element-503">
              Pure Kenyan Essential Oils
              <span className="block mt-2 text-[#2e7d32]" data-id="element-504">
                Straight from Nature
              </span>
            </h2>
            <p className="text-gray-600 mb-8 text-lg" data-id="element-505">
              At Shiriaka Essentials, we harness the power of Kenya's rich
              botanical diversity to create premium quality essential oils. Each
              bottle captures the pure essence of plants grown in our country's
              pristine landscapes.
            </p>
            <div className="flex flex-col sm:flex-row gap-4" data-id="element-506">
              <Link to="/about" className="bg-[#2e7d32] hover:bg-[#1b5e20] text-white px-6 py-3.5 rounded-lg font-medium transition-colors duration-300 inline-flex items-center justify-center shadow-md group" data-id="element-507">
                Our Process
                <ArrowRightIcon className="ml-2 h-4 w-4 transition-transform group-hover:translate-x-1" data-id="element-508" />
              </Link>
              <Link to="/products" className="bg-white text-[#2e7d32] border border-[#2e7d32] hover:bg-[#f0f7eb] px-6 py-3.5 rounded-lg font-medium transition-colors duration-300 inline-flex items-center justify-center" data-id="element-509">
                Shop Now
              </Link>
            </div>
          </div>
          <div className="relative" data-id="element-510">
            <div className="rounded-2xl overflow-hidden shadow-xl" data-id="element-511">
              <img src="https://images.unsplash.com/photo-1564515963098-cb5ee5c1f4f7?q=80&w=600&auto=format&fit=crop" alt="Essential oil production in Kenya" className="w-full h-full object-cover" onError={e => {
              e.currentTarget.src = 'https://images.unsplash.com/photo-1595981267035-7b04ca84a82d?q=80&w=600&auto=format&fit=crop';
            }} data-id="element-512" />
            </div>
            <div className="absolute -bottom-6 -right-6 bg-white p-4 rounded-lg shadow-lg hidden md:block" data-id="element-513">
              <div className="flex items-center space-x-3" data-id="element-514">
                <div className="w-10 h-10 rounded-full bg-[#e8f5e9] flex items-center justify-center" data-id="element-515">
                  <LeafIcon className="h-5 w-5 text-[#2e7d32]" data-id="element-516" />
                </div>
                <div data-id="element-517">
                  <p className="font-medium text-gray-900" data-id="element-518">100% Pure</p>
                  <p className="text-sm text-gray-500" data-id="element-519">No additives</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
};
export default WelcomeSection;